import { Product } from "../Model/Product";
import { ProductRepository } from "../Repository/ProductRepository";


export interface GetProductByIdUseCase {
  invoke: (productId: number) => Promise<Product | null>;
}

export class GetProductById implements GetProductByIdUseCase {
  private productRepo: ProductRepository;
  constructor(_ProductRepo: ProductRepository) {
    this.productRepo = _ProductRepo;
  }

   invoke(productId: number){
    if(!productId){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
    const getData = this.productRepo.getProductById(productId);
    return getData;
  }
}